import { post } from '../axios'

interface AddWishlistProps {
  userId: number
  productId: number
}

const addWishlist = async ({ userId, productId }: AddWishlistProps) => {
  const url = '/hyperlocal/v1/wishlist/add'
  try {
    await post(url, {
      user_id: userId,
      product_id: productId,
    })
    return true
  } catch (e) {
    console.error(e)
    return false
  }
}
export default addWishlist
